import { render, staticRenderFns } from "./ShoplistFilter.vue?vue&type=template&id=08d320cb&"
import script from "./ShoplistFilter.vue?vue&type=script&lang=js&"
export * from "./ShoplistFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d320cb')) {
      api.createRecord('08d320cb', component.options)
    } else {
      api.reload('08d320cb', component.options)
    }
    module.hot.accept("./ShoplistFilter.vue?vue&type=template&id=08d320cb&", function () {
      api.rerender('08d320cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/ShoplistFilter.vue"
export default component.exports